
<template>
    <form v-bind:class="{active: isActive}">
        <!-- Фильтр -->
        <span class="text-lg font-semibold block text-center mb-3" style="color:rgba(var(--vs-primary), 1)">
           {{ history.student?fullName(history.student):'' }}
        </span>

        <div class="mb-4  w-full">
            <multiselect
                v-model="VisorData"
                style="z-index:53001"
                class="w-full"
                :options="statuses"
                :placeholder="$t('choose_status')"
                :selectedLabel="$t('selected')"
                @remove="multiselectRemove"
                @select="multiselectAction"
                @open="fetchStudyPlan"
                @close="closefetchStudyPlan"
                :loading="loading"
                v-validate="'required'"
                label="name"
                name="status"
                track-by="uid">
                    <template slot="singleLabel" slot-scope="props">{{ props.option.name }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.name }}</template>
                    <div slot="noOptions">{{$t('no_data_text')}}</div>
            </multiselect>
            <span class="text-danger text-sm" v-show="errors.has('status')">{{ $t('validation_required') }}</span>
        </div>
        <div class="vx-col w-full" v-show="openArea">
            <vs-textarea class="mb-0" name="description" :label="$t('answer')"
                v-model="description" />
        </div>
<!--        <div class="vx-col w-full" style="position: relative;">-->
            <vs-button type="filled"  @click="formSubmit" class="mt-4 block pay_btn w-full lg:w-auto">
                {{$t('send')}}
            </vs-button>
<!--        </div>-->

    </form>
</template>


<script>
import axios from '@/configs/Axios'
import userSetting from '@/localNodeModules/setting/user.js'

export default {
    name: 'form-change-visor',
    props:{
        history:{
            type:Object,
        }
    },
    mixins:[userSetting],
    data() {
        return {
            VisorData: null,
            studyPlan: [],
            statuses: [],
            loading: false,
            description: '',
            isActive : false,
        }
    },
    computed: {
        emptyMessage() {
            // Если нет активного студ плана, показываем сообщение
            if (!this.VisorData) return true
        },
        user() {
            return this.$store.state.user.user
        },

        openArea(){
            if(this.VisorData && (this.VisorData.alias == "accepted" || this.VisorData.alias == "declined")){
                return true
            }
            return false;
        }
    },

    methods: {
        closefetchStudyPlan(){
            this.isActive = false;
        },
        multiselectRemove() {
            // Очищаем данные со студ планом и списком пользователей
            this.VisorData = null
        },
        multiselectAction(item) {
            // Выбираем студ план и запрашиваем список пользователей
            this.VisorData = item
        },
        async fetchStudyPlan() {
            // console.log(this.VisorData);
            // Запрашиваем студ план
            try {
                this.$vs.loading({
                    scale: 0.45
                })
                this.loading = true

                await axios.get(`/organizations/request_status`)
                    .then((res)=>{
                        this.statuses = res.data
                    })
                    .catch((err)=>{
                        this.$vs.notify({
                            text: this.$t('error'),
                            color: 'danger'
                        })
                    });





            } catch (e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger'
                })
            } finally {
                this.loading = false
                this.$vs.loading.close()
            }
            if (this.VisorData==null){
                this.isActive = true;
            }else if (this.VisorData.alias=="declined"||this.VisorData.alias=="accepted"){
                this.isActive = false;
            }else {
                this.isActive = true;
            }

        // else if (this.VisorData == null){
        //         this.isActive = true;
        //     }

        },

        async formSubmit() {
            this.$validator.validateAll().then(async result => {

                await axios.put(`/organizations/request_advisor_detail/${this.history.uid}/`,
                    {
                        "status":this.VisorData.uid,
                        "comment":this.description
                    }
                ).then((res)=>{
                    this.description = '';
                    this.VisorData = null;
                    this.$emit('update',true)
                    if(res.data.message){
                        this.$vs.notify({
                            text: res.data.message,
                            color: 'danger'
                        })
                    }else{
                        this.$vs.notify({
                            text: this.$t('your_application_successfully_send'),
                            color: 'success'
                        })
                    }
                    this.$emit('close');

                }).catch(err=>{
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                })

            });

        }
    }

}

</script>
<style scoped>
.active{
    padding: 0px 0px 115px 0px;
}
</style>
